<template>
  <v-dialog :value="value" max-width="480px" @input="$emit('input', $event)">
    <v-card v-if="person">
      <v-card-title>
        {{ isPlaced ? 'Cambiar jefe o área' : 'Ubicar en el árbol' }}
        <v-spacer />
        <v-btn icon aria-label="Cerrar" @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-subtitle class="pt-1">{{ person.name }}<span v-if="person.title"> · {{ person.title }}</span></v-card-subtitle>

      <v-card-text>
        <v-form ref="form" @submit.prevent="save">
          <org-chart-placement-fields
            v-model="placement"
            :people="managerOptions"
            :areas="areas"
            :disabled="saving"
            required
          />
        </v-form>
        <v-alert v-if="errorText" type="error" dense text class="mt-3 mb-0">{{ errorText }}</v-alert>
      </v-card-text>

      <v-card-actions class="pa-4 pt-0">
        <v-spacer />
        <v-btn text :disabled="saving" @click="close">Cancelar</v-btn>
        <v-btn color="primary" depressed :loading="saving" @click="save">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ClientOrgChartsService from '../services/client-org-charts.service';
import OrgChartPlacementFields from './OrgChartPlacementFields.vue';
import { HEAD_OPTION, collectDescendantIds, errorMessage, toPlacement } from '../utils/org-chart.utils';

// Elige jefe y área de una persona. Sirve para "Ubicar en el árbol" y "Cambiar jefe o área".
export default {
  name: 'PlacePersonModal',
  components: { OrgChartPlacementFields },
  props: {
    value: { type: Boolean, default: false },
    orgId: { type: [Number, String], required: true },
    person: { type: Object, default: null },
    // Personas ubicadas en el árbol (lista plana).
    nodes: { type: Array, default: () => [] },
    unplaced: { type: Array, default: () => [] },
    areas: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      placement: { manager: null, area: null },
      saving: false,
      errorText: ''
    };
  },
  computed: {
    isPlaced() {
      return !!this.person && this.nodes.some(node => node.personId === this.person.personId);
    },
    // Nadie puede reportar a sí mismo ni a alguien que está debajo suyo.
    managerOptions() {
      if (!this.person) return [];
      const excluded = collectDescendantIds(this.nodes, this.person.personId);
      excluded.add(this.person.personId);
      return [...this.nodes, ...this.unplaced].filter(candidate => !excluded.has(candidate.personId));
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(open) {
        if (open) this.reset();
      }
    }
  },
  methods: {
    reset() {
      this.errorText = '';
      this.saving = false;
      if (!this.person) return;
      const manager = this.isPlaced
        ? (this.person.managerPersonId === null || this.person.managerPersonId === undefined ? HEAD_OPTION : this.person.managerPersonId)
        : null;
      this.placement = { manager, area: this.person.area || null };
      if (this.$refs.form) this.$refs.form.resetValidation();
    },
    close() {
      this.$emit('input', false);
    },
    async save() {
      if (this.$refs.form && !this.$refs.form.validate()) return;
      const body = toPlacement(this.placement);
      if (!body) return;
      this.saving = true;
      this.errorText = '';
      const res = await ClientOrgChartsService.savePosition(this.orgId, this.person.personId, body);
      this.saving = false;
      if (res.status !== 'ok') {
        this.errorText = errorMessage(res, 'No pudimos guardar el cambio. Intenta de nuevo.');
        return;
      }
      // Payload: { personId, managerPersonId, area }
      this.$emit('saved', { personId: this.person.personId, ...body });
      this.close();
    }
  }
};
</script>
